import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-pink-900 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Sohkin Flower Gifts</h3>
            <p className="text-pink-200">
              Delivering happiness through beautiful flowers and gifts since 2010.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="hover:text-pink-300"><Facebook /></a>
              <a href="#" className="hover:text-pink-300"><Instagram /></a>
              <a href="#" className="hover:text-pink-300"><Twitter /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-pink-300">Home</Link></li>
              <li><Link to="/shop" className="hover:text-pink-300">Shop All</Link></li>
              <li><Link to="/shop?category=roses" className="hover:text-pink-300">Roses</Link></li>
              <li><Link to="/shop?category=combos" className="hover:text-pink-300">Combos</Link></li>
              <li><Link to="/about" className="hover:text-pink-300">About Us</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Customer Service</h4>
            <ul className="space-y-2">
              <li><Link to="/faq" className="hover:text-pink-300">FAQ</Link></li>
              <li><Link to="/shipping-policy" className="hover:text-pink-300">Shipping Policy</Link></li>
              <li><Link to="/return-policy" className="hover:text-pink-300">Return Policy</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-pink-300">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-pink-300">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <Phone className="h-5 w-5" />
                <span>+91 98765 43210</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-5 w-5" />
                <span>info@sohkinflowergifts.com</span>
              </div>
              <div className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 mt-1" />
                <span>123 Flower Street, Garden City, Delhi 110001</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-pink-800 mt-8 pt-6 text-center">
          <p>&copy; {currentYear} Sohkin Flower Gifts. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;